"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RosettaConstructionParseResponseToJSON = exports.RosettaConstructionParseResponseFromJSONTyped = exports.RosettaConstructionParseResponseFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function RosettaConstructionParseResponseFromJSON(json) {
    return RosettaConstructionParseResponseFromJSONTyped(json, false);
}
exports.RosettaConstructionParseResponseFromJSON = RosettaConstructionParseResponseFromJSON;
function RosettaConstructionParseResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'operations': (json['operations'].map(_1.RosettaOperationFromJSON)),
        'signers': !runtime_1.exists(json, 'signers') ? undefined : json['signers'],
        'account_identifier_signers': !runtime_1.exists(json, 'account_identifier_signers') ? undefined : (json['account_identifier_signers'].map(_1.RosettaAccountIdentifierFromJSON)),
        'metadata': !runtime_1.exists(json, 'metadata') ? undefined : json['metadata'],
    };
}
exports.RosettaConstructionParseResponseFromJSONTyped = RosettaConstructionParseResponseFromJSONTyped;
function RosettaConstructionParseResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'operations': (value.operations.map(_1.RosettaOperationToJSON)),
        'signers': value.signers,
        'account_identifier_signers': value.account_identifier_signers === undefined ? undefined : (value.account_identifier_signers.map(_1.RosettaAccountIdentifierToJSON)),
        'metadata': value.metadata,
    };
}
exports.RosettaConstructionParseResponseToJSON = RosettaConstructionParseResponseToJSON;
//# sourceMappingURL=RosettaConstructionParseResponse.js.map